export default "__VITE_ASSET__B0zuQ$2A__";